"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var TextField = function (_a) {
  var field = _a.field;
  var Tag = field.model.htmlTag || 'p';
  return react_1.default.createElement(Tag, {
    className: field.model.cssClass
  }, field.model.text);
};
exports.default = TextField;